import React from 'react'
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import {useSelector, connect, useDispatch} from 'react-redux';
import axios from 'axios';
import {useNavigate} from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import { CCard, CButton
} from 'compat/coreui';
const required = (value) => (value ? undefined : "Required");

const renderField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <div >
      <input {...input} placeholder={label} type={type}/>
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
  </div>
)



function StepFour(props) {

  const { handleSubmit, reset, setPage } = props;

  const values = useSelector(state => state.form.sellerForm && state.form.sellerForm.values);
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const submit = (e) =>{
    e.preventDefault()
    if (!props.valid) {
      // props.touch("address1");
      // props.touch("city");
      // props.touch("state");

    } else {
        let url= `${process.env.REACT_APP_APP_API_URL}/api/auth/registerForSeller`
        let formData = new FormData();
        formData.append("businessName", values.businessName);
        formData.append("businessEmail", values.businessEmail);
        formData.append("phone", values.phone);
        formData.append("webUrl", values.webUrl);
        formData.append("businessType", values.businessType);
        formData.append("address", values.address1);
        formData.append("address2", values.address2 || '');
        formData.append("city", values.city);
        formData.append("state", values.state);
        formData.append("operationTime", 1);
        // formData.append("photos", values.photos[0]);
        if(props.picture)
        formData.append("photos", props.picture);
        formData.append("pincode", values.zipcode);
        formData.append("password", values.userPassword);
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        return axios.post(url, formData, config).then(response => {
          if(response.status === 200){
            toast.success("Registration Successful!");
            dispatch(reset('sellerForm'));
            navigate('/profile')
          }
        }).catch(e => {
          if (e && e.response && e.response.data.message) {
            toast.error(e.response.data.message);
          }
        })
    }
  }

    return (
        <div className="tour4 step_five">
            <div className="package_overview">
            <div className="wrapper">
            <div className="short_grid1">
            <CCard className="grid_column1 featured value selected1">
                <div className="ribbon1 ribbon-top-left"><span>Best Value</span></div>
                <div className="title1"><h2>PREMIUM</h2></div>
                    <span className="price1">$3000<span>/mo</span></span>
                    <ul className="details">
                        <li><strong>15 Mile Local</strong> Exposure</li>
                        <li><strong>Premium</strong> Map Icon</li>
                        <li><strong>Advanced</strong> Menus &amp; Products</li>
                        <li><strong>Promoted</strong> Daily Deals</li>
                        <li>Page 1 of Results</li>
                        <li>Online Pre-Ordering</li>
                        <li>Business Analytics </li>
                        <li>Call Tracking</li>
                        <li>Marketing Materials</li>
                    </ul>
                    <div className="cta">
                        <div>
                            <CButton color="warning" className="m-3 pl-5 pr-5 text-white" onClick={(e) => {submit(e)}}>TRY</CButton>
                            <CButton color="success" className="m-3 pl-5 pr-5" onClick={(e) => {submit(e)}}>BUY</CButton>
                        </div>
                        <span className="trial">7 DAY FREE TRIAL!</span>
                    </div>
                </CCard>
                <CCard className="grid_column1 premium1">
                    <div className="title1"><h2>Featured</h2></div>
                    <span className="price1">$1,300<span>/mo</span></span>
                    <ul className="details">
                        <li><strong>10 Mile Local</strong> Exposure</li>
                        <li><strong>Featured</strong> Map Icon</li>
                        <li><strong>Advanced</strong> Menus &amp; Products</li>
                        <li><strong>Promoted</strong> Daily Deals</li>
                        <li>Page 1 of Results</li>
                        <li>Online Pre-Ordering</li>
                        <li>Business Analytics </li>
                        <li>Call Tracking</li>
                        <li>Marketing Materials</li>
                    </ul>
                    <div className="cta">
                    <div>
                        <CButton color="warning" className="m-3 pl-5 pr-5 text-white" onClick={(e) => {submit(e)}}>
                            TRY
                        </CButton>
                        <CButton color="success" className="m-3 pl-5 pr-5" onClick={(e) => {submit(e)}}>
                            BUY
                        </CButton>
                    </div>
                    <span className="trial">7 DAY FREE TRIAL!</span></div>
                </CCard>
                <CCard className="grid_column1 verified1">
                    <div className="title1"><h2>Verified</h2></div>
                    <span className="price1">$650<span>/mo</span></span>
                    <ul className="details">
                        <li><strong>5 Mile Local</strong> Exposure</li>
                        <li><strong>Verified</strong> Map Icon</li>
                        <li><strong>Advanced</strong> Menu &amp; Products</li>
                        <li><strong>Promoted</strong> Daily Deals</li>
                        <li>Page 1 of Results</li>
                        <li>Online Pre-Ordering</li>
                        <li>Business Analytics </li>
                        <li>Call Tracking</li>
                        <li>Marketing Materials</li>
                   </ul>
                    <div className="cta">
                        <CButton color="success" className="pl-5 pr-5 mt-4" onClick={(e) => {submit(e)}}>BUY</CButton>
                        <div style={{height: '32px'}}/>
                    </div>
                </CCard>
                <CCard className="grid_column1 claimed1">
                    
                    <div className="title1"><h2>Claimed</h2></div>
                        <span className="price1">$0<span>/mo</span></span>
                        <ul className="details">          
                            <li><strong>Local</strong> Exposure</li>
                            <li><strong>Standard</strong> Map Icon</li>
                            <li><strong>Limited</strong> Menu &amp; Products</li>
                            <li>Page 2+ of Results</li>
                            <li>Business Analytics </li>
                       </ul>
                    <div className="cta" style={{marginTop: '68px'}}>
                    <div>
                        <CButton color="warning"  className="mt-5 text-white" onClick={(e) => {submit(e)}}>CHOOSE</CButton>
                    </div>
                     <span className="trial">&nbsp;</span>
                    </div>
                </CCard>
            </div>
            {/*<button className="btn btn-primary" onClick={() => {props.setPage(3)}}>Prev</button>
            <button className="btn btn-primary" onClick={(e) => {submit(e)}}>Submit</button>*/}
            </div>
            </div>
        </div>
    )
}

let MainReduxForm = reduxForm({form: 'sellerForm', destroyOnUnmount: false})(StepFour)

export default MainReduxForm = connect((state) => ({
  synchronousError: getFormSyncErrors("sellerForm")(state), // change name here
}))(MainReduxForm);
